module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allocation.component.css
// module id = ./src/app/allocation/allocation.component.css
// module chunks = main